import { jarvisPrimeDashboardConstants } from "./jarvisPrimeDashboardConstants";

const jarvisPrimeDashboardActions = {};

jarvisPrimeDashboardActions.getPortfolioAllocations = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALLOCATIONS_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioOverview = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_OVERVIEW_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioPerformance = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PERFORMANCE_SAGA,
});
jarvisPrimeDashboardActions.getCustomerStories = () => ({
  type: jarvisPrimeDashboardConstants.CUSTOMER_STORIES_SAGA,
});

jarvisPrimeDashboardActions.getWelcomeVideosList = () => ({
  type: jarvisPrimeDashboardConstants.WELCOME_VIDEO_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioChart = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_CHART_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioSector = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_SECTOR_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioMarket = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_MARKET_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioAlert = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_ALERT_SAGA,
});

jarvisPrimeDashboardActions.getPortfolioPendingTransaction = () => ({
  type: jarvisPrimeDashboardConstants.PRIME_PORTFOLIO_PENDING_TRANSACTION_SAGA,
});

jarvisPrimeDashboardActions.dashboardRefresh = () => ({
  type: jarvisPrimeDashboardConstants.DASHBOARD_REFRESH_SAGA,
});

export { jarvisPrimeDashboardActions };
